exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3LIogh8k0t{font-size:22px;font-weight:700;margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"title": "_3LIogh8k0t"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!./~/postcss-loader!./~/sass-loader?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./src/react/elements/ReviewList/ReviewForm.scss
// module id = 956
// module chunks = 20